import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Funder } from 'src/app/shared/models/funder';
import { ConstantsService } from '../../constant/constants.service';
import { GenericCrudService } from '../../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class FunderService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllFunders(): Observable<Funder[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.funderUrl}`,
			'getAllFunders'
		);
	}

	addFunder(funder: Funder): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.funderUrl}`,
			`addFunder`,
			funder
		);
	}

	updateFunder(funder: Funder): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.funderUrl}`,
			`updateFunder`,
			funder
		);
	}
}
